 <svg
        class="animated-svg"
        [attr.viewBox]="'0 0 ' + width() + ' ' + (height() + 120)"
        preserveAspectRatio="xMidYMin meet">
        
        <g wall-type-6 [height]="height()"></g>
        
        <g roof-type-6/>
        <g outline />
        <g window-type-4 [height]="height()"/>

</svg>